import type { DocumentUpload } from '@gcv/shared';
import { useMutation } from '@tanstack/react-query';

import { DocumentsApi } from 'api';
import { useUser } from 'hooks/queries';
import { uploadOrgDocumentToS3 } from 'util/s3.util';
import { BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY } from '../../keys';
import { useFiInternalDocumentsCache } from '../useFiInternalDocumentsCache';

export function useUploadInternalDocuments(dispensaryId: string) {
  const { userBankId } = useUser();
  const documentsApi = new DocumentsApi();
  const { addDocumentsToCache } = useFiInternalDocumentsCache(dispensaryId);

  const { mutateAsync: uploadInternalDocuments, isPending: isUploadingInternalDocuments } = useMutation({
    mutationKey: [BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY],
    mutationFn: async ({ files, path }: { files: File[]; path: string }) => {
      const documents: DocumentUpload[] = [];
      const folder = [userBankId, dispensaryId, path].filter(Boolean).join('/');

      for (const file of files) {
        const s3Key = await uploadOrgDocumentToS3(file, folder);
        documents.push(await documentsApi.putDocument(file.name, s3Key, userBankId));
      }
      return documents;
    },
    onSuccess: (documents) => addDocumentsToCache(documents),
    meta: {
      snackbarSuccessMessage: 'Documents successfully uploaded',
      snackbarErrorMessage: 'There was an issue uploading documents.'
    }
  });
  return { uploadInternalDocuments, isUploadingInternalDocuments };
}
